<div *ngIf="{dropdowns: dropdowns$ | async, currentEmployee: authenticatedEmployee$ | async} as data">
  <div *ngIf="data.dropdowns" [@enterAnimation]>
    <div fxLayoutAlign="space-between center">
      <h2>Edit Case</h2>
      <div fxLayout="column">
        <div fxLayout="row">
          <button mat-icon-button class="secondary cancel-button" (click)="cancel()">
            <mat-icon [ngClass]="{'cancel-icon-unsaved': caseForm.dirty}">cancel</mat-icon>
          </button>
          <button [disabled]="caseForm.invalid" mat-icon-button color="primary" (click)="save(caseForm.getRawValue())">
            <mat-icon>save</mat-icon>
          </button>
        </div>

        <div class="unsaved-div" [ngClass]="{'cancel-icon-unsaved': caseForm.dirty }" fxLayout="row"
          *ngIf="caseForm && caseForm.dirty">
          Unsaved Changes
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="basicWarrantyExpired">
      <mat-icon color="primary">info</mat-icon>
      <span class="expired-warranty">Please note that the basic warranty has expired for this vehicle.</span>
    </div>
    <form id="caseForm" class="container form-container" fxLayout="row wrap" fxLayoutAlign="start center"
      [formGroup]="caseForm" novalidate>
      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Submission Type</mat-label>
          <mat-select name="warrantySubmissionTypeId" formControlName="warrantySubmissionTypeId">
            <mat-option *ngFor="let st of data.dropdowns.submissionTypes" [value]="st.id">
              {{st.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20"
        *ngIf="filteredServiceGroups$ | async as serviceGroups">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>Op Code</mat-label>
          <mat-select name="opCode" formControlName="opCode" id="opCode">
            <mat-option *ngFor="let sg of filterServiceGroups(serviceGroups) | orderBy: 'name'" [value]="sg.workOrderLocationOpCode">
              {{sg.workOrderLocationOpCode}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Estimated Time</mat-label>
          <input id="estimatedTime" type="number" matInput (blur)="checkTenths(['estimatedTime'])"
            formControlName="estimatedTime">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Recommended Time</mat-label>
          <input id="recommendedHours" type="number" matInput (blur)="checkTenths(['recommendedHours'])"
            formControlName="recommendedHours">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Start Time</mat-label>
          <input id="startTime" type="time" matInput formControlName="startTime">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxFlex="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Tech/Tech Group</mat-label>
          <mat-select name="technicianGroupId" formControlName="techOrTechGroup"
            (selectionChange)="techOrGroupSelected($event,data.dropdowns.technicians,data.dropdowns.technicianGroups)">
            <mat-optgroup>
              <label fxFlex class="w-full">
                Tech Groups
              </label>
              <mat-option
                *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                [value]="tg.id">
                {{tg.description}}
              </mat-option>
            </mat-optgroup>
            <mat-optgroup>
              <label fxFlex class="w-full">
                Technicians
              </label>
              <mat-option
                *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId"
                [value]="tg.associateId">
                {{tg.embedded.associate.firstName}} {{tg.embedded.associate.lastName}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="20">
        <mat-form-field appearance="fill">
          <mat-label>Campaign #</mat-label>
          <input id="campaignNumber" matInput formControlName="campaignNumber" oninput="this.value = this.value.toUpperCase()">
        </mat-form-field>
      </div>

      <div class="service-group-container" fxLayout="row" fxLayoutAlign="space-between center" fxFlex fxFlex.sm="100"
        *ngIf="filteredServiceGroups$ | async as serviceGroups">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>Service Group</mat-label>
          <mat-select panelClass="service-group-select" name="serviceGroupId" formControlName="serviceGroupId"
            (selectionChange)="serviceGroupSelected($event, serviceGroups, data.currentEmployee.rooftopId)">
            <mat-option *ngFor="let serviceGroup of serviceGroups | orderBy: 'name'" [value]="serviceGroup.id">
              {{serviceGroup.name}}
            </mat-option>
          </mat-select>
          <button *ngIf="caseForm.get('serviceGroupId').value" mat-button matSuffix mat-icon-button aria-label="Clear"
            (click)="clearServiceGroup(); $event.preventDefault(); $event.stopPropagation();">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button mat-button mat-icon-button class="mb-5 ml-1 mr-3"
          (click)="serviceGroupLookup(serviceGroups, data.currentEmployee.rooftopId)">
          <mat-icon color="primary">search</mat-icon>
        </button>
      </div>

      <div class="description-container" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="100"
        fxFlex.gt-sm="100">
        <mat-form-field appearance="fill">
          <mat-label>Case Description</mat-label>
          <textarea id="requestDescription" matInput formControlName="requestDescription"></textarea>
        </mat-form-field>
      </div>
    </form>

    <!-- <div fxLayoutAlign="space-between center">
      <span class="mat-subheading-2">Service Group</span>
      <div>
        <button mat-icon-button class="secondary" (click)="save(caseForm.value)">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div> -->
  </div>
</div>